import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useSingleStoreAction } from '../../../hooks/store/store';
import { useFieldArray, useForm } from 'react-hook-form';
import SubTitle from '../../ui/SubTitle';
import OpeningHoursInputs from '../createStoreForms/OpeningHoursInputs';
import ActiveDaysSelector from '../createStoreForms/ActiveDaysSelector';
import PickupMethodsSelector from '../createStoreForms/PickupMethodsSelector';
import SubmitButton from '../../form/SubmitButton';
import { useUpdateResource } from '../../../hooks/useUpdateResource';
import LoadingButton from '../../form/LoadingButton';
import LoadingErrorState from '../../ui/LoadingErrorState';
import { formatOpeningHoursForSubmit, parseOpeningHoursFromAPI } from '../../../utils/formatOpiningHours';

interface Page3FormData {
  pickupMethods: { in_store: boolean; drive_thru: boolean };
  openingHours: { day: string; openTime: string | null; closeTime: string | null }[];
}

const daysOfWeek = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

function UpdateOpiningHours() {
    const {t} = useTranslation();
    const { storeId} = useParams<{ storeId: string}>();
    const numericStoreId = storeId ? parseInt(storeId) : undefined;
    const {data:store,isError,isLoading} = useSingleStoreAction(numericStoreId);
    const { register, handleSubmit, setValue, control, watch } = useForm<Page3FormData>({
        defaultValues: {
            pickupMethods:{in_store:store?.inStore,drive_thru:store?.driveThru},
          openingHours:daysOfWeek.map((day) => ({ day, openTime: null, closeTime: null })),
        },
      });

        const { fields } = useFieldArray({ control, name: "openingHours" });
        const [activeDays, setActiveDays] = useState<{ [day: string]: boolean }>({});

        useEffect(()=>{
            if(store){
              console.log(parseOpeningHoursFromAPI(store.openingHours))
                setValue("pickupMethods",{in_store:store.inStore, drive_thru:store.driveThru});
                setValue("openingHours",parseOpeningHoursFromAPI(store.openingHours));
            }
        },[setValue,store])
      
        useEffect(() => {
          const initActive: { [day: string]: boolean } = {};
          fields.forEach((f) => {
            initActive[f.day] = !!f.openTime && !!f.closeTime;
          });
          setActiveDays(initActive);
        }, [fields]);
      
        const toggleDay = (day: string) => {
          setActiveDays((prev) => {
            const newActive = { ...prev, [day]: !prev[day] };
            if (!newActive[day]) {
              const idx = fields.findIndex((f) => f.day === day);
              setValue(`openingHours.${idx}.openTime`, null);
              setValue(`openingHours.${idx}.closeTime`, null);
            }
            return newActive;
          });
        };


        const { loading, updateResource } = useUpdateResource();
              
        const onSubmit = (data: Page3FormData) => {
            // call API to create category
            const url =numericStoreId?`store?storeId=${numericStoreId}`:"store";
            updateResource(url, {
                driveThru:data.pickupMethods.drive_thru,
                inStore:data.pickupMethods.in_store,
                openingHours:formatOpeningHoursForSubmit(data.openingHours)
            },
                numericStoreId? "admin":"store",{
            method: "PUT",
            successMessage: t("update_success"),
            invalidateQueries:["store-detail-action"],
            });
        };

  return (
    <div >
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />
       {
        store &&
         <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-6 w-full">
            <SubTitle title={t("pickup_methods_available")} />
            <PickupMethodsSelector watch={watch} setValue={setValue} />
            <SubTitle title={t("opening_hours")} />
              <OpeningHoursInputs watch={watch} setValue={setValue} toggleDay={toggleDay}   control={control} fields={fields} activeDays={activeDays} setActiveDays={setActiveDays}/>
            <div>
                {
                    loading
                    ?
                    <LoadingButton/>
                    :
                    <SubmitButton label='update'/>
                }
            </div>
        </form>
       }
    </div>
  )
}

export default UpdateOpiningHours